import React, {PureComponent} from 'react'

import styles from './InlineCode.less'

export default class InlineCode extends PureComponent {
    render() {
        const {isTiny, children} = this.props
        const classes = []
        classes.push(styles.inlineCode)

        if (isTiny) {
            classes.push(styles.inlineCode_tiny)
        }

        return (
            <span className={classes.join(' ')}
                  onClick={(e) => {
                      if (window.getSelection) {
                          window.getSelection().selectAllChildren(e.target)
                      } else { // старый IE
                          const range = document.selection.createRange()
                          range.moveToElementText(e.target)
                          range.select()
                      }
                  }}>
				{children}
			</span>
        )
    }
}
